<template>
  <div id="partner-box-types">
    <div class="box-title">
      {{ $t("partnerPicker.boxes.title") }}
    </div>
    <div class="box-type-wrapper">
      <div
        v-for="(item, index) in boxTypes"
        :key="Math.round() + index"
        class="box-item"
      >
        <partner-box-type-item
          :ref="`box-item-${index}`"
          :type="index"
          :key="Math.round() + index"
          :boxes="item"
        />
      </div>
    </div>
    <transition name="fade">
      <div class="add-wrapper" v-if="getPartner.moved && getPartner.moved == 1">
        <rounded-button
          :isOutline="true"
          width="170px"
          height="27px"
          class="button"
          position="left"
          @click="addBoxesToStore"
        >
          {{ $t("partnerBoxTypeItem.boxTypes.addButton") }}
        </rounded-button>
      </div>
    </transition>
    <transition name="fade">
      <div class="error-message" v-if="errMessage">
        {{ $t("partnerBoxTypeItem.boxTypes.noBoxSelected") }}
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PartnerBoxTypeItem from "./PartnerBoxTypeItem";
export default {
  name: "PartnerBoxTypes",
  props: {
    boxes: {
      type: Array,
      required: true
    }
  },
  components: {
    PartnerBoxTypeItem
  },
  data: () => ({
    errMessage: false
  }),
  mounted() {},
  watch: {
    getPartner() {
      if (this.getPartner.moved) {
        this.setPartnerMovingBoxes(undefined);
      }
    }
  },
  computed: {
    ...mapGetters({
      getPartner: "moving/getPartner"
    }),
    boxTypes() {
      const types = { 0: [], 1: [], 2: [] };

      this.boxes.forEach(element => {
        types[element["type"]].push(element);
      });
      return types;
    }
  },
  methods: {
    ...mapActions({
      removeQR: "moving/removeQR",
      saveQR: "moving/saveQR",
      setPartnerMovingBoxes: "moving/setPartnerMovingBoxes"
    }),
    addBoxesToStore() {
      const boxes = [
        ...this.$refs["box-item-0"][0].movingBoxes,
        ...this.$refs["box-item-1"][0].movingBoxes,
        ...this.$refs["box-item-2"][0].movingBoxes
      ];
      if (boxes.length <= 0) {
        this.errMessage = true;
        return;
      }

      this.saveQR(boxes);
      this.setPartnerMovingBoxes(boxes);
      if (this.getPartner.moved && this.getPartner.partner) {
        this.$parent.$parent.currentScreenIndex = 2;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#partner-box-types {
  margin-top: 20px;
  .box-title {
    font-size: 16px;
    font-weight: 550;
    margin-bottom: 10px;
  }
  .error-message {
    color: red;
    font-size: 12px;
    margin-left: 5px;
    margin-top: 5px;
  }
  .add-wrapper {
    margin-top: 10px;
    .button {
      /deep/ button {
        font-size: 11px;
      }
    }
  }
}
</style>
